module.exports = __webpack_public_path__ + "static/browse-token-list-0def4a09110ca5a572c20d4babca8e78.png";